import { useState, useEffect } from "react";
import { Home, ArrowLeft, Search, RefreshCw, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const [countdown, setCountdown] = useState(10);
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleGoHome = () => {
    setIsAnimating(true);
    setTimeout(() => {
      navigate("/");
    }, 300);
  };

  const handleGoBack = () => {
    setIsAnimating(true);
    setTimeout(() => {
      navigate(-1);
    }, 300);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 overflow-hidden relative">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-10 -left-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-bounce"></div>
        <div className="absolute top-1/4 right-10 w-16 h-16 bg-indigo-200 rounded-full opacity-40 animate-pulse"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-purple-200 rounded-full opacity-30 animate-ping"></div>
        <div
          className="absolute bottom-32 right-1/3 w-8 h-8 bg-pink-200 rounded-full opacity-50 animate-bounce"
          style={{ animationDelay: "1s" }}
        ></div>
      </div>

      <div
        className={`max-w-2xl w-full text-center transition-all duration-300 ${
          isAnimating ? "scale-95 opacity-80" : "scale-100 opacity-100"
        }`}
      >
        <div className="relative mb-8">
          <div className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 animate-pulse">
            404
          </div>
          <div className="absolute inset-0 text-8xl md:text-9xl font-black text-blue-100 -z-10 transform translate-x-1 translate-y-1">
            404
          </div>

          <MapPin
            className="absolute top-4 left-1/4 w-6 h-6 text-blue-400 animate-bounce"
            style={{ animationDelay: "0.5s" }}
          />
          <Search
            className="absolute top-12 right-1/4 w-5 h-5 text-purple-400 animate-bounce"
            style={{ animationDelay: "1.5s" }}
          />
          <RefreshCw className="absolute bottom-8 left-1/3 w-4 h-4 text-indigo-400 animate-spin" />
        </div>

        <div className="bg-white/80 rounded-3xl shadow-xl border border-white/20 p-8 md:p-12 mb-8 transform transition-all duration-500 hover:shadow-2xl hover:-translate-y-1">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Oops! Page Not Found
          </h1>

          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Looks like you've wandered off the beaten path. The page you're
            looking for seems to have gone on an adventure of its own.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <button
              onClick={handleGoHome}
              className="group flex items-center gap-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-2xl font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-300"
            >
              <Home className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
              Go Home
            </button>

            <button
              onClick={handleGoBack}
              className="group flex items-center gap-3 bg-white text-gray-700 px-8 py-4 rounded-2xl font-semibold border-2 border-gray-200 transition-all duration-300 hover:shadow-lg hover:scale-105 hover:border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-300"
            >
              <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-300" />
              Go Back
            </button>
          </div>

          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-100">
            <p className="text-sm text-gray-600">
              Don't worry, we'll automatically take you home in{" "}
              <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-600 text-white rounded-full text-sm font-bold animate-pulse">
                {countdown}
              </span>{" "}
              seconds
            </p>
          </div>
        </div>

        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          {[
            { icon: "🏠", text: "Visit our homepage" },
            { icon: "🔍", text: "Try our search" },
            { icon: "📞", text: "Contact support" },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white/60 rounded-2xl p-4 transition-all duration-300 hover:bg-white/80 hover:scale-105 cursor-pointer"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="text-2xl mb-2">{item.icon}</div>
              <div className="text-gray-600 font-medium">{item.text}</div>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export { NotFoundPage };
